<template>
  <v-container class="fluid-max-width pa-0">
    <v-breadcrumbs :items="breadcrumbItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <div v-if="!isLoading">
      <h4 class="text-center mt-4" v-if="!orders || orders.length === 0">
        {{
          isOnline
            ? 'Keine Bestellungen vorhanden'
            : 'Keine Internetverbindung. Bitte Verbindung herstellen.'
        }}
      </h4>
      <v-expansion-panels flat tile class="orders-list" v-else>
        <v-expansion-panel
          v-for="item in orders"
          :key="item.order_key"
          class="mb-1"
        >
          <v-expansion-panel-header class="grey lighten-3">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" md="2" class="ma-0 pa-0">
                <h4 class="ma-0 pa-0 mb-1">
                  {{ formatDate(item.order_date) }}
                </h4>
                <span>{{ formatTime(item.order_date) }} Uhr</span>
              </v-col>
              <v-col cols="6" sm="4" class="ma-0 pa-0">
                <h4>{{ item.site_id.name }}</h4>
                <span class="subtitle">{{ item.site_id.street }}</span>
                <span class="subtitle" v-if="item.site_id.street">, </span>
                <span class="subtitle">
                  {{ item.site_id.postal_code }} {{ item.site_id.city }}
                </span>
              </v-col>
              <v-col cols="12" sm="6" class="ma-0 pa-0 mt-4 mt-md-0">
                <h4 class="subtitle">
                  {{
                    item.shafts.length == 1
                      ? item.shafts[0].title
                      : item.shafts.length + ' Schächte'
                  }}
                  <span v-if="getOrderUserString(item)"
                    >bestellt {{ getOrderUserString(item) }}</span
                  >
                </h4>
                <span class="subtitle" v-if="item.delivery_date">{{
                  getDeliveryDateString(item)
                }}</span>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <OrdersList :shafts="item.shafts" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-else>
      <v-skeleton-loader
        v-for="n in 5"
        :key="n"
        class="ma-0 mb-2"
        height="64"
        type="image"
        tile
      ></v-skeleton-loader>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  formatDate,
  formatTime,
  getOrderUserString,
  getDeliveryDateString,
} from '@/utils/utils';
import OrdersList from '@/components/OrdersList.vue';

export default {
  name: 'Orders',
  components: { OrdersList },
  data: () => ({
    isLoading: false,
    breadcrumbItems: [
      {
        text: 'Home',
        disabled: false,
        to: '/',
      },
      {
        text: 'Bestellungen',
        disabled: true,
        to: '/bestellungen',
      },
    ],
  }),
  computed: {
    ...mapGetters(['orders', 'user']),
    isOnline() {
      return navigator.onLine;
    },
  },
  async created() {
    this.isLoading = true;
    await this.autoLogin();
    await this.getOrders();
    this.isLoading = false;
  },
  methods: {
    ...mapActions(['autoLogin', 'getUser', 'getOrders', 'setCurrentShaft']),
    formatDate,
    formatTime,
    getOrderUserString,
    getDeliveryDateString,
    onShaftClicked(item) {
      this.setCurrentShaft(item);
      this.$router.push('/schacht/' + item.id);
    },
  },
};
</script>

<style scoped>
.orders-list h4 {
  margin-bottom: 5px;
}

.orders-list >>> .v-expansion-panel-content__wrap {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>
